/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Section5_P1Inputs */

const en_privacy_section5_p1 = /** @type {(inputs: Privacy_Section5_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PureJSON is available as a PWA that can be installed on your device. Once installed, the app works entirely offline. No network requests are made during offline use, further ensuring your data privacy.`)
};

const ko_privacy_section5_p1 = /** @type {(inputs: Privacy_Section5_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PureJSON은 기기에 설치할 수 있는 PWA로 제공됩니다. 설치 후에는 완전히 오프라인으로 작동하며, 오프라인 사용 시 네트워크 요청이 발생하지 않아 데이터 프라이버시가 더욱 보장됩니다.`)
};

const ja_privacy_section5_p1 = /** @type {(inputs: Privacy_Section5_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PureJSONはデバイスにインストール可能なPWAとして利用できます。インストール後は完全にオフラインで動作し、オフライン使用時にはネットワークリクエストが発生しないため、データプライバシーがさらに保証されます。`)
};

/**
* | output |
* | --- |
* | "PureJSON is available as a PWA that can be installed on your device. Once installed, the app works entirely offline. No network requests are made during offl..." |
*
* @param {Privacy_Section5_P1Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const privacy_section5_p1 = /** @type {((inputs?: Privacy_Section5_P1Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Section5_P1Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_privacy_section5_p1(inputs)
	if (locale === "ko") return ko_privacy_section5_p1(inputs)
	return ja_privacy_section5_p1(inputs)
});